import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm } from 'redux-form';
import { formSettings } from '../settings';
import { FormattedMessage } from 'react-intl';
import WizardButtons from '../../../../../../components/wizard/navigator/buttons';
import Signature from '../../../../../../components/signature';
import messages from '../../../../../../text/messages';
import { setProgressionProperties, getAssignmentLetter } from '../../../../../../reducers/onboarding';
import { maskSSN } from '../../../../../../utilities/string';
import { getAddresses } from '../../../../../../reducers/addresses';
import { getSignatures, createAssignmentW2 } from '../../../../../../reducers/documents';
import { sign } from '../../../../../../reducers/signatures';
import { Signatures } from '../../../../../../utilities/signatureTypes';
import mixpanel from 'mixpanel-browser';
class AssignmentLetterStep extends React.Component {
    constructor(props) {
        super(props);

        this.submit = this.submit.bind(this);
    }

    componentDidMount() {
        mixpanel.track('WorkerOnboarding', { _data: { branch: 'employee', step: 'AssignmentLetterStep' } });

        const { assignmentLetter, role, profile, job, progression, getAddresses, getSignatures, getAssignmentLetter, setProgressionProperties } = this.props;
        getSignatures(role, signaturesResult =>
            setProgressionProperties({
                assignmentLetterSignature: signaturesResult.find(s => s.name === `${Signatures.types.ASSIGNMENT_LETTER_W2.name}:${job.id}`) !== undefined
            })
        );

        if (!assignmentLetter) {
            getAssignmentLetter(job.id, role.id, role.type, 'assignment');
        }

        if (!progression || !progression.personalInformation || !progression.mailingAddress) {
            getAddresses(role, addresses => {
                setProgressionProperties({
                    personalInformation: {
                        firstName: profile.first_name,
                        middleName: profile.middle_name,
                        lastName: profile.last_name,
                        email: profile.email,
                        phoneNumber: profile.phone,
                        dateOfBirth: profile.birthday_date,
                        socialSecurityNumber: maskSSN(profile.ssn_bg_check)
                    }
                });

                if (addresses && addresses.length > 0) {
                    setProgressionProperties({ mailingAddress: addresses[0] });
                }
            });
        }
    }

    submit(values, action) {
        const { role, job, sign, setProgressionProperties, createAssignmentW2 } = this.props;

        sign(role, `${Signatures.types.ASSIGNMENT_LETTER_W2.name}:${job.id}`, signature => {
            setProgressionProperties({ assignmentLetterSignature: true });
            createAssignmentW2(job.id, job.contractor_id, signature.id);
            action();
        });
    }

    render() {
        const { handleSubmit, onSubmit, back, submitting, job, progression, assignmentLetter } = this.props;
        if (
            !progression ||
            !progression.personalInformation ||
            !progression.mailingAddress ||
            progression.assignmentLetterSignature === undefined ||
            !assignmentLetter
        ) {
            return null;
        }

        return (
            <form onSubmit={handleSubmit(values => this.submit(values, onSubmit))}>
                <div className="row section">
                    <div className="col-xs-12">
                        <div className="scrolled" dangerouslySetInnerHTML={{ __html: assignmentLetter }} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12">
                        <Signature name={`${Signatures.types.ASSIGNMENT_LETTER_W2.name}:${job.id}`} />
                    </div>
                </div>

                <WizardButtons disabled={submitting} back={{ action: back }} submit={{ message: <FormattedMessage {...messages.signAndContinue} /> }} />
            </form>
        );
    }
}

AssignmentLetterStep = reduxForm(formSettings)(AssignmentLetterStep);

const mapStateToProps = state => {
    let progression = state.onboarding.progression;
    return {
        role: state.identity.role,
        profile: state.identity.profile,
        job: state.onboarding.job,
        client: state.onboarding.client,
        clientAddress: state.onboarding.address,
        position: state.onboarding.position,
        projects: state.onboarding.projects,
        assignmentLetter: state.onboarding.assignmentLetter,
        progression,
        initialValues: {
            acknowledgeAssignmentLetterSignature: progression.assignmentLetterSignature
        }
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getAddresses,
            getSignatures,
            getAssignmentLetter,
            createAssignmentW2,
            sign,
            setProgressionProperties
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(AssignmentLetterStep);



// WEBPACK FOOTER //
// ./src/pages/onboarding/tenants/contractor/steps/employee/assignmentLetter.jsx